import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMiniComponent } from './simple-icons-mini.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMiniComponent ],
    exports:      [ SimpleIconsMiniComponent ],
    bootstrap:    []
})
export class SimpleIconsMiniModule {}
